<template>
    <div class="travelPaymentEdit">
        <table>
            <tr>
                <td class="fixedcell">日付：</td>
                <td><input class="paydate" type="date" v-model="payDateEx" @change="paydate_change"/></td>
                <div v-if="iconFlag" class="icon_area">
                    <span><icon name="ellipsis-v" class="icon" scale="0.8" @click.stop="menu_popup($event)"></icon></span>
                </div>
            </tr>
            <tr>
                <td class="fixedcell">交通機関：</td>
                <td><input class="facilities" type="text" v-model="facilitiesEx" @change="facilities_change"/></td>
            </tr>
            <tr>
                <td colspan="2"><input class="from" type="text" v-model="fromEx" @change="from_change"/> &rarr; <input class="to" type="text" v-model="toEx" @change="to_change"/></td>
            </tr>
            <tr>
                <td class="fixedcell">金額：</td>
                <td class="money_area"><input class="money" type="text" v-model="moneyEx" @focus="money_focus" @blur="money_blur"/><span>円</span></td>
            </tr>
        </table>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: "travelPaymentEdit",
    props: {
        payDate: { type: String, default: "" },
        facilities: { type: String, default: "" },
        from: { type: String, default: "" },
        to: { type: String, default: "" },
        money: { type: String, default: "" }
    },
    data() {
        return {
            payDateEx: "",
            facilitiesEx: "",
            fromEx: "",
            toEx: "",
            moneyEx: "",
            preMoney: "",
            iconFlag: true
        }
    },
    watch: {
        payDate(nv, ov) {
            this.payDateEx = nv;
            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            } else {
                this.iconFlag = true;
            }
        },
        facilities(nv, ov) {
            this.facilitiesEx = nv;
            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            } else {
                this.iconFlag = true;
            }
        },
        from(nv, ov) {
            this.fromEx = nv;
            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            } else {
                this.iconFlag = true;
            }
        },
        to(nv, ov) {
            this.toEx = nv;
            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            } else {
                this.iconFlag = true;
            }
        },
        money(nv, ov) {
            this.moneyEx = this.getAmount(nv);
            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            } else {
                this.iconFlag = true;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.payDateEx = this.payDate;
            this.facilitiesEx = this.facilities;
            this.fromEx = this.from;
            this.toEx = this.to;
            this.moneyEx = this.getAmount(this.money);

            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            }
        });
    },
    methods: {
        menu_popup(e) {
            this.$emit('menu_popup', e);
        },
        money_focus() {
            this.moneyEx = this.moneyEx.replace(",", "");
            this.preMoney = this.moneyEx;
        },
        money_blur() {
            let money = this.moneyEx.replace(",", "");
            this.moneyEx = this.getAmount(money);
            if (money != this.preMoney) {
                this.$emit("change_money", money);
            }
        },
        paydate_change() {
            if (this.payDateEx == "" || this.payDateEx == undefined) {
                this.iconFlag = false;
            } else {
                this.iconFlag = true;
            }
            this.$emit("paydate_change", this.payDateEx);
        },
        facilities_change() {
            this.$emit("facilities_change", this.facilitiesEx);
        },
        from_change() {
            this.$emit("from_change", this.fromEx);
        },
        to_change() {
            this.$emit("to_change", this.toEx);
        },
        getAmount(val) {
            return Vue.$utils.convertCurrency(val);
        }
    }
}
</script>

<style lang="less" scoped>
.travelPaymentEdit {
    width: 100%;
    border: 1px solid #999;
    border-radius: 6px;
    padding: 4px;

    table {
        width: 100%;
    }

    .paydate {
        width: 114px;
        height: 28px;
    }

    .facilities {
        width: 100%;
        height: 28px;
    }

    .from, .to {
        width: calc(50% - 13px);
        height: 28px;
    }

    .money_area {

        .money {
            width: 100px;
            height: 28px;
            text-align: right;
        }

        span {
            margin-left: 4px;
        }
    }

    .fixedcell {
        text-align: right;
        width: 90px;
    }

    .icon_area {
        text-align: right;
        padding-top: 4px;

        span {
            margin-right: -2px;
            cursor: pointer;

            .icon {
                width: 14px;
                fill: var(--foreColor);
            }
        }
    }
}
</style>